"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgGaming(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M20 24.084c-1.651 0-3.062.237-4.234.71-.31.125-.58.33-.785.591-3.664 4.71-6.728 6.456-9.192 5.241C2 28.757 1.053 24.084 2.947 18.476 4.842 12.87 7.684 11 10.527 11H20M20 24.084c1.651 0 3.062.237 4.234.71.31.125.58.33.785.591 3.664 4.71 6.728 6.456 9.192 5.241 3.789-1.869 4.736-6.542 2.842-12.15C35.158 12.87 32.316 11 29.473 11H20", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M10.087 17v6.042M13 20H7", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M32.5 21a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM29.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM29.5 24a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM26.5 21a1.5 1.5 0 100-3 1.5 1.5 0 000 3z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgGaming;
//# sourceMappingURL=Gaming.js.map